import { render, staticRenderFns } from "./PlanejamentoContratoForm.vue?vue&type=template&id=0bffb645"
import script from "./PlanejamentoContratoForm.vue?vue&type=script&lang=js"
export * from "./PlanejamentoContratoForm.vue?vue&type=script&lang=js"
import style0 from "./PlanejamentoContratoForm.vue?vue&type=style&index=0&id=0bffb645&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports